import React from 'react';
import ListMap from '../ListMap';
import request from 'arcdynamic-request';
import {PROPERTIES} from '../../consts/tables';

export default class PropertyMap extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			property: null,
		};
	}

	componentDidMount() {
		this.getProperty(this.props.params.id);
	}

	getProperty(id) {
		request(arc.path.api, {
			service: 'arcimedes',
			action: 'open.datasource.table.Data.getData',
			params: ['code', PROPERTIES, {
				filter: [{
					'text': id,
					'code': 'ARCIMEDES_ROW_ID',
					'type': 'exact',
				}],
			}],
		}).then(res => {
			if (res && res.success && Array.isArray(res.data) && res.data.length) {
				this.setState({
					property: res.data[0],
					error: null,
				});
			} else {
				this.setState({
					property: false,
					error: res.message ? res.message : 'Unidentified Error',
				})
			}
		});
	}

	render() {
		const p = this.state.property;
		const zoom = this.props.location.query && this.props.location.query.zoom ? parseInt(this.props.location.query.zoom) : 14;
		const mapTypeId = this.props.location.query && this.props.location.query.mapTypeId ? this.props.location.query.mapTypeId : 'roadmap';

		if (p === null) {
			return null;
		} else if (p.LATITUDE && p.LONGITUDE) {
			return (
				<div className='PropertyMap'>
					<ListMap listings={[p]} latitude={p.LATITUDE} longitude={p.LONGITUDE} zoom={zoom} mapTypeId={mapTypeId}/>
				</div>
			);
		} else {
			return (
				<div>Address is either missing, failed to geocode, or has yet to be geocoded.</div>
			);
		}
	}
}
